module.exports = __webpack_public_path__ + "static/media/makeThingsClear.f861c5c4.svg";